import { IUISupplier } from '@bridebook/toolbox/src/types';
import { mapSupplierToAnalyticsRecord } from '@bridebook/web/lib/search/utils/map-suppliers/map-supplier-to-analytics-record';
import { VenueAnalyticsShape } from '@bridebook/web/lib/search/utils/map-suppliers/shapes';

const mapVenuesToAnalyticsVenues = (list: IUISupplier[]) =>
  list.map(mapSupplierToAnalyticsRecord(VenueAnalyticsShape));

export default mapVenuesToAnalyticsVenues;
